module.exports = __webpack_public_path__ + "9f03142855f2acc3346bb04140a1eb34.png";